module.exports = require("@emotion/styled-base");